import React, { useEffect, useState } from "react";
import "./PersonalAnalysis.css";
import config from "../config";  // adjust the path as needed


const PersonalAnalysis = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [loggedIn, setLoggedIn] = useState(false);

  // Input parameters
  const [baseRange, setBaseRange] = useState("");
  const [compareRange, setCompareRange] = useState("");
  const [positionRange, setPositionRange] = useState("1");

  // Popup controls
  const [showCustomize, setShowCustomize] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const [showTradingCodePopup, setShowTradingCodePopup] = useState(false);

  // Customize fields
  const [selectedTradingCodes, setSelectedTradingCodes] = useState([]);
  const [lowerRange, setLowerRange] = useState("");
  const [upperRange, setUpperRange] = useState("");
  const [publicShare, setPublicShare] = useState("");
  const [category, setCategory] = useState("");

  // ✅ Fetch Data (Reusable Function)
  // const fetchData = async (params = {}) => {
  //   const token = localStorage.getItem("token");
  //   if (token) setLoggedIn(true);

  //   setLoading(true);
  //   setError(null);

  //   try {
  //     // Build query string
  //     const queryParams = new URLSearchParams(params).toString();
  //     const url = `http://127.0.0.1:8000/indicators/personal-analysis/${queryParams ? `?${queryParams}` : ""}`;

  //     const response = await fetch(url, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         ...(token && { Authorization: `Token ${token}` }),
  //       },
  //     });

  //     if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

  //     const result = await response.json();
  //     setData(result);
  //   } catch (err) {
  //     console.error("Fetch error:", err);
  //     setError("Failed to load data. Please check your API or network.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };





const fetchData = async (params = {}) => {
  const token = localStorage.getItem("token");
  if (token) setLoggedIn(true);

  setLoading(true);
  setError(null);

  try {
    const queryParams = new URLSearchParams(params).toString();
    // const url = `http://127.0.0.1:8000/indicators/personal-analysis/${queryParams ? `?${queryParams}` : ""}`;
    // const url = `https://dseapi.sadhanlab.com/indicators/personal-analysis/${queryParams ? `?${queryParams}` : ""}`;
    const url = `${config.API_BASE_URL}indicators/personal-analysis/${queryParams ? `?${queryParams}` : ""}`;



    
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Token ${token}` }),
      },
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const result = await response.json();

    // ✅ New: populate input fields from parameter
    if (result.parameter) {
      setBaseRange(result.parameter.base_day ?? "");
      setCompareRange(result.parameter.recent_day ?? "");
      setPositionRange(result.parameter.user_month_position ?? "1");
    }

    // ✅ Use data for table operations
    setData(result.data ?? []);
  } catch (err) {
    console.error("Fetch error:", err);
    setError("Failed to load data. Please check your API or network.");
  } finally {
    setLoading(false);
  }
};









  // ✅ Initial Fetch
  useEffect(() => {
    fetchData();
  }, []);

  // ✅ Handle Load Button
  // const handleLoad = () => {
  //   if (!baseRange || !compareRange || !positionRange) {
  //     alert("Please fill all parameter fields before loading.");
  //     return;
  //   }

  //   const params = {
  //     base_day: baseRange,
  //     recent_day: compareRange,
  //     user_month_position: positionRange,
  //   };

  //   fetchData(params);
  // };




  
// ✅ Updated handleLoad
const handleLoad = () => {
  if (!loggedIn) {
    alert("Login required to load data.");
    return;
  }

  if (!baseRange || !compareRange || !positionRange) {
    alert("Please fill all parameter fields before loading.");
    return;
  }

  const params = {
    base_day: baseRange,
    recent_day: compareRange,
    user_month_position: positionRange,
  };

  fetchData(params);
};
  


// ✅ Updated Customize Display button handler
const handleCustomizeClick = () => {
  if (!loggedIn) {
    alert("Login required to customize display.");
    return;
  }
  setShowCustomize(true);
};





  // Extract headers dynamically
  const headers =
    data.length > 0 ? Object.keys(data[0]).filter((k) => k !== "Date") : [];

  const reportDate = data[0]?.Date
    ? new Date(data[0].Date).toISOString().split("T")[0]
    : null;

  const prettyHeader = (h) =>
    h
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase())
      .trim();

  // const renderCell = (value) => {
  //   if (value === null || value === undefined) return "-";
  //   if (typeof value === "number") {
  //     const formatted = value.toLocaleString(undefined, {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     });
  //     if (value > 0) return <span className="positive">▲ {formatted}</span>;
  //     if (value < 0) return <span className="negative">▼ {formatted}</span>;
  //     return <span className="neutral">{formatted}</span>;
  //   }
  //   return String(value);
  // };



const renderCell = (value, key) => {
  if (value === null || value === undefined) return "-";

  // Columns that should always be plain black
  const plainColumns = ["Position_in_Range", "Public_Share"];
  // console.log(key)

  if (plainColumns.includes(key)) {
    // show as normal number or string in black
    if (typeof value === "number") {
      const formatted = value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return <span style={{ color: "black" }}>{formatted}</span>;
    }
    return <span style={{ color: "black" }}>{String(value)}</span>;
  }

  // Default behavior for other columns
  if (typeof value === "number") {
    const formatted = value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    if (value > 0) return <span className="positive">▲ {formatted}</span>;
    if (value < 0) return <span className="negative">▼ {formatted}</span>;
    return <span className="neutral">{formatted}</span>;
  }

  return String(value);
};











  // Sorting
  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return data;
    return [...data].sort((a, b) => {
      const valA = a[sortConfig.key];
      const valB = b[sortConfig.key];
      if (valA === null || valA === undefined) return 1;
      if (valB === null || valB === undefined) return -1;
      if (typeof valA === "number" && typeof valB === "number") {
        return sortConfig.direction === "asc" ? valA - valB : valB - valA;
      }
      return sortConfig.direction === "asc"
        ? String(valA).localeCompare(String(valB))
        : String(valB).localeCompare(String(valA));
    });
  }, [data, sortConfig]);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Derive available trading codes and categories from fetched data
  const availableTradingCodes = [
    ...new Set(data.map((d) => d.Code).filter(Boolean)),
  ];
  const availableCategories = [
    ...new Set(data.map((d) => d.Category).filter(Boolean)),
  ];

  // Filter data by selected trading codes and category
  const filteredData = sortedData.filter((item) => {
    let show = true;
    if (selectedTradingCodes.length > 0) {
      show = selectedTradingCodes.includes(item.Code);
    }
    if (category) {
      show = show && item.Category === category;
    }
    return show;
  });

  if (loading)
    return (
      <div className="loader-container">
        <div className="loader"></div>
        Loading data...
      </div>
    );
  if (error) return <div className="error-message">{error}</div>;
  if (!data.length) return <div className="no-data">No data found.</div>;

  return (
    <div className="analysis-container">
      <h2 className="analysis-title">📊 Stock Analysis</h2>

      {reportDate && (
        <p className="report-date">
          Report Date: <span>{reportDate}</span>
        </p>
      )}

      {/* Parameter Section */}
      <div className="parameter-section">
        {/* <h3>Customize Parameters</h3> */}
        <h3>⚙️ Customize Parameters</h3>

        <div className="form-grid">
          <label>
            Base Day Range (max 730)
            <input
              type="number"
              max="730"
              value={baseRange}
              onChange={(e) => setBaseRange(e.target.value)}
              // disabled={!loggedIn}
            />
          </label>

          <label>
            Compare Day Range (≤ Base)
            <input
              type="number"
              max="730"
              value={compareRange}
              onChange={(e) => setCompareRange(e.target.value)}
              // disabled={!loggedIn}
            />
          </label>

          <label>
            Position Range (1–24)
            <select
              value={positionRange}
              onChange={(e) => setPositionRange(e.target.value)}
              // disabled={!loggedIn}
            >
              {Array.from({ length: 24 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>
          </label>

          <button className="load-btn" onClick={handleLoad} 
          // disabled={!loggedIn}
          >
            Load
          </button>
        </div>

        {/* <div className="button-row">
          <button onClick={() => setShowCustomize(true)}>Customize Display</button>
          <button onClick={() => setShowDescription(true)}>Description</button>
        </div> */}


        <div className="button-row">
          <button onClick={handleCustomizeClick}>Customize Display</button>
          <button onClick={() => setShowDescription(true)}>Description</button>
        </div>



      </div>

      {/* Customize Popup */}
      {showCustomize && (
        <div className="popup-backdrop" onClick={() => setShowCustomize(false)}>
          <div className="popup-window" onClick={(e) => e.stopPropagation()}>
            <h3>Customize Display</h3>

            <label>
              Trading Codes
              <input
                type="text"
                readOnly
                placeholder="Select Trading Codes..."
                value={selectedTradingCodes.join(", ")}
                onClick={() => setShowTradingCodePopup(true)}
              />
            </label>

            {showTradingCodePopup && (
              <div
                className="popup-backdrop"
                onClick={() => setShowTradingCodePopup(false)}
              >
                <div className="popup-window" onClick={(e) => e.stopPropagation()}>
                  <h4>Select Trading Codes</h4>

                  <div className="select-buttons">
                    <button
                      onClick={() => setSelectedTradingCodes([...availableTradingCodes])}
                    >
                      Select All
                    </button>
                    <button onClick={() => setSelectedTradingCodes([])}>
                      Deselect All
                    </button>
                  </div>

                  <div className="trading-code-list">
                    {availableTradingCodes.map((code) => (
                      <label key={code}>
                        <input
                          type="checkbox"
                          checked={selectedTradingCodes.includes(code)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedTradingCodes([...selectedTradingCodes, code]);
                            } else {
                              setSelectedTradingCodes(
                                selectedTradingCodes.filter((c) => c !== code)
                              );
                            }
                          }}
                        />
                        {code}
                      </label>
                    ))}
                  </div>

                  <div className="popup-buttons">
                    <button onClick={() => setShowTradingCodePopup(false)}>Done</button>
                  </div>
                </div>
              </div>
            )}

            <label>
              Show Category
              <select
                value={category === "all" ? "" : category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value="">Select...</option>
                {availableCategories.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </label>

            <div className="popup-buttons">
              <button onClick={() => setShowCustomize(false)}>Save</button>
              <button onClick={() => setShowCustomize(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Description Popup */}
      {showDescription && (
        <div className="popup-backdrop" onClick={() => setShowDescription(false)}>
          <div className="popup-window" onClick={(e) => e.stopPropagation()}>
            <h3>About This Section</h3>
            <p>
              This panel lets users customize the displayed stock data. Logged-in users can
              adjust input parameters and filter the dataset. Guests can view but not edit.
              The table shows calculated performance, price, and volume changes over time.
            </p>
            <div className="popup-buttons">
              <button onClick={() => setShowDescription(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="table-container">
        <table className="analysis-table">
          <thead>
            <tr>
              {headers.map((h) => (
                <th key={h} onClick={() => requestSort(h)}>
                  {prettyHeader(h)}{" "}
                  {sortConfig.key === h
                    ? sortConfig.direction === "asc"
                      ? "▲"
                      : "▼"
                    : ""}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, i) => (
              <tr key={i} className={i % 2 === 0 ? "even-row" : "odd-row"}>
                {headers.map((key) => (

                    <td key={key}>{renderCell(item[key], key)}</td>

                  // <td key={key}>{renderCell(item[key])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PersonalAnalysis;
